import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromRouter from '../module-router-selectors';
import { CompanyModuleRouterUtils } from '../../utils/company-module-router/company-module-router.utils';

@Injectable()
export class CompanyModuleRouterFacade {
  readonly #store = inject(Store);
  readonly #redirectService = new CompanyModuleRouterUtils();

  readonly url = this.#store.selectSignal(fromRouter.selectUrl);

  readonly queryParams = this.#store.selectSignal(fromRouter.selectQueryParams);

  readonly companyId = this.#store.selectSignal(fromRouter.selectCompanyId);
  readonly companyId$ = this.#store.select(fromRouter.selectCompanyId);

  readonly module = this.#store.selectSignal(fromRouter.selectModule);

  readonly submodule = this.#store.selectSignal(fromRouter.selectSubmodule);

  readonly detailId = this.#store.selectSignal(fromRouter.selectDetailId);

  companyRoutePath(options?: { companyId?: number | 'create' }): string {
    const companyId = options?.companyId ?? this.companyId();

    return this.#redirectService.companyPath(companyId);
  }

  moduleRoutePath(options?: { companyId?: number; module?: string }): string {
    const companyId = options?.companyId ?? this.companyId();
    const module = options?.module ?? this.module();

    return this.#redirectService.modulePath(companyId, module);
  }

  submoduleRoutePath(options?: { companyId?: number; module?: string; submodule?: string }): string {
    const companyId = options?.companyId ?? this.companyId();
    const module = options?.module ?? this.module();
    const submodule = options?.submodule ?? this.submodule();

    return this.#redirectService.submodulePath(companyId, module, submodule);
  }

  detailRoutePath(options?: { companyId?: number; module?: string; submodule?: string; detailId?: string | number }): string {
    const companyId = options?.companyId ?? this.companyId();
    const module = options?.module ?? this.module();
    const submodule = options?.submodule ?? this.submodule();
    const detailId = options?.detailId ?? this.detailId();

    return this.#redirectService.detailPath(companyId, module, submodule, detailId);
  }
}
